/**
 * Cabecera del dashboard de estadísticas: icono, título y subtítulo.
 *
 * La comparten el dashboard y la vista de carga (pages/DashboardEstadisticasCargando),
 * para que al entrar en /estadisticas la Card y su título ya estén en pantalla
 * mientras llega el chunk diferido, en vez de aparecer de golpe después.
 *
 * NO importa nada del feature más allá de MUI: es el único fichero de
 * estadísticas que viaja en el chunk inicial (lo arrastra routes.js a través de
 * la vista de carga), así que cualquier import que se le añada acaba
 * descargándose en TODAS las pantallas de la aplicación.
 */

import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";

const CabeceraDashboard = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });

    return (
        <Box sx={{ p: 3, pb: 2 }}>
            <Typography
                variant={isMobile ? "h6" : "h5"}
                sx={{
                    fontWeight: 700,
                    color: "#212529",
                    mb: 0.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <InsightsIcon sx={{ fontSize: isMobile ? 24 : 28 }} />
                Estadísticas
            </Typography>
            <Typography variant="body2" sx={{ color: "#6c757d" }}>
                Actividad del almacén por periodo: volumen, horas punta, días, rutas y empleados
            </Typography>
        </Box>
    );
};

export default CabeceraDashboard;
